@if (((sharingMode && allNoteData.length > 0) || !sharingMode) && !isNoteDataLoading) {
<div class="w-full">
  @if (inlineComponent) {
  <p class="app__form--attribute--title text-xl font-semibold leading-8 text-[#53565b] mb-7">
    Suggested
    <span class="text-[#25508e]"> Additional Notes </span>
    for
    <span class="text-[#25508e]"> {{ data?.form_name }}</span>
  </p>
  }
  <div
    class="app__template--linked--header flex justify-between items-center text-sm leading-6"
    [ngClass]="{ 'mr-6': !inlineComponent && fId != 1, 'mb-4': fId == 1 }"
  >
    @if (!inlineComponent) {
    <span class="text-[18px]">Notes</span>
    } @if (inlineComponent) {
    <span class="font-semibold"
      >Notes
      <span class="text-[#25508e]"> ({{ notesData.length }})</span>
    </span>
    } @if (!sharingMode) {
    <span
      class="app__form--attribute--title app__centered-item justify-start text-sm"
      [ngClass]="{ 'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
      (click)="!isRemoveEditSaveSharing ? openModal() : null"
    >
      <span class="material-icons">add</span>
      <span class="ml-1"> Add New </span>
    </span>
    }
  </div>
  @if (allNoteData?.length > 0 && !allNoteDataRejectedData) {
  <div class="app__centered-item justify-start flex-wrap gap-[20px] p-0">
    @for (note of showAllNotes ? allNoteData : allNoteData; track note) { @if(note?.vault_user_form_note_suggestion_note_status !== 'rejected'){
    <notes-list-component
      [selectedSecurity_key]="selectedSecurity_key"
      [fId]="fId"
      [note]="note"
      [style]="
        screenWidth >= 480 && !isIpadOrTabletScreenWidth() && fId != 1
          ? 'width: 48%'
          : isIpadOrTabletScreenWidth() && screenWidth >= 480
          ? 'width:100%'
          : 'width:100%'
      "
      (getNote)="getNotesForForm()"
      (createNote)="openModal($event)"
      [inlineComponent]="inlineComponent"
      [securityStateObject]="securityStateObject"
      (removeNote)="deleteSuggestionForAdditionalNote($event)"
      [isEditable]="!!(mode !== 'view' && !sharingMode)"
      [actionDisabled]="isRemoveEditSaveSharing"
      [isIpadOrTabletScreenWidth]="isIpadOrTabletScreenWidth() && screenWidth >= 480"
    ></notes-list-component>
    } }
  </div>
  } @else {
  <div [class]="!inlineComponent && fId != 1 ? 'mr-7' : ''">
    <div
      class="app__centered-item app__solid--border w-full border-[#D3DCE8] rounded-lg text-center"
      [ngClass]="{ 'h-[64px] bg-white': fId == 1, 'h-[68px]': fId != 1 }"
    >
      <span>
        <img [src]="fId == 1 ? '/assets/images/note-placeholder.svg' : '/assets/images/note-placeholder-icon.svg'" />
        <span class="app__form--attribute--title font-semibold leading-[24px] text-[#707070] pl-2" [class]="fId == 1 ? 'text-[12px]' : 'text-sm'">
          No <span [class]="fId == 1 ? 'text-[#25508E] font-bold' : ''">Notes</span> to show
        </span></span
      >
    </div>
  </div>
  }
</div>
}
